import React from 'react';
import { NavLink } from 'react-router-dom';
import { Plus } from 'lucide-react';
import ComposeModal from '../components/ComposeModal';

const mockThreads = [
  {
    id: '1',
    title: 'CS101 Staff',
    lastMessage: "Don't forget the meeting tomorrow.",
    timestamp: '10:24 AM',
    unread: 2,
  },
  {
    id: '2',
    title: 'Project Group A',
    lastMessage: 'I have updated the doc.',
    timestamp: 'Yesterday',
    unread: 0,
  },
  {
    id: '3',
    title: 'Jordan Carter',
    lastMessage: 'Thanks for the feedback!',
    timestamp: 'Mar 10',
    unread: 1,
  },
];

export default function InboxPage() {
  const [showCompose, setShowCompose] = React.useState(false);

  return (
    <div className="flex h-full overflow-hidden">
      <aside className="w-80 border-r bg-white dark:bg-gray-900 flex flex-col">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">Messages</h2>
          <button
            onClick={() => setShowCompose(true)}
            className="p-1 text-primary hover:text-primary/80"
          >
            <Plus />
          </button>
        </div>
        <ul className="flex-1 overflow-y-auto">
          {mockThreads.map((thread) => (
            <li key={thread.id}>
              <NavLink
                to={`/app/inbox/${thread.id}`}
                className={({ isActive }) =>
                  `flex items-center justify-between px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-800 ${
                    isActive ? 'bg-gray-100 dark:bg-gray-800 font-medium' : ''
                  }`
                }
              >
                <div>
                  <p>{thread.title}</p>
                  <p className="text-sm text-gray-500">{thread.lastMessage}</p>
                </div>
                <div className="flex flex-col items-end">
                  <span className="text-xs text-gray-400">{thread.timestamp}</span>
                  {thread.unread > 0 && (
                    <span className="mt-1 rounded-full bg-primary px-2 text-xs text-white">
                      {thread.unread}
                    </span>
                  )}
                </div>
              </NavLink>
            </li>
          ))}
        </ul>
      </aside>
      <div className="flex-1 flex items-center justify-center bg-gray-50 dark:bg-gray-800">
        <p className="text-gray-500">Select a conversation or compose a new message.</p>
      </div>
      {showCompose && <ComposeModal onClose={() => setShowCompose(false)} />}
    </div>
  );
}